import React from 'react'
import {
  MenuProps as MUIMenuProps,
  Theme,
  Menu as MUIMenu
} from '@mui/material'

import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'

const CustomMenu: React.FC<MUIMenuProps> = ({
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'left'
  },
  ...props
}) => (
  <MUIMenu
    keepMounted
    transformOrigin={transformOrigin}
    anchorOrigin={anchorOrigin}
    {...props}
  />
)
export const StyledMenu = withStyles(() => ({
  paper: {
    border: '0.0625rem solid #F1F1F1',
    borderRadius: '8px',
    boxSizing: 'border-box',
    boxShadow: '0 10px 10px 0 rgba(66,81,89,0.2)'
  }
}))(CustomMenu)

type StylesType = {
  disablePadding?: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    position: 'relative',
    margin: '0',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  children: {
    display: 'flex',
    flexDirection: 'column',
    outline: '0'
  },

  options: {
    display: 'flex',
    flexDirection: 'column',

    '& > :first-child': {
      paddingTop: ({ disablePadding }) => (disablePadding ? '0' : '0.75rem')
    },

    '& > :last-child': {
      paddingBottom: ({ disablePadding }) => (disablePadding ? '0' : '0.75rem')
    }
  },

  title: {
    opacity: '0.7',
    marginRight: '5px',
    marginBottom: '13px',
    color: '#323436'
  },

  close: {
    position: 'absolute',
    top: '10px',
    right: '-8px',
    opacity: '0.2',
    fontSize: theme.size.sm,
    userSelect: 'none',

    '&:hover': {
      cursor: 'pointer'
    }
  }
}))

export default useStyles
